import { Suspense, lazy } from 'react';
import { useRoutes } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';

import UserLayout from '@/layouts/UserLayout';
import AdminLayout from '@/layouts/AdminLayout';
import AuthLayout from '@/layouts/AuthLayout';
import { AdminGuard } from './guards';
import { userRoutes, authRoutes, notFoundRoute } from './userRoutes';
import { adminRoutes } from './adminRoutes';

const AdminLoginPage = lazy(() => import('@/pages/admin/AdminLoginPage'));

/** 全局加载回退组件 */
function LoadingFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-500 border-t-transparent" />
    </div>
  );
}

/** 完整路由配置 */
const routes: RouteObject[] = [
  // ===== 用户网站 =====
  {
    path: '/',
    element: <UserLayout />,
    children: userRoutes,
  },
  // ===== 认证页面 =====
  {
    path: '/',
    element: <AuthLayout />,
    children: authRoutes,
  },
  // ===== 管理后台登录（无外层 layout，页面自带全屏背景） =====
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  // ===== 管理后台 =====
  {
    path: '/admin',
    element: (
      <AdminGuard>
        <AdminLayout />
      </AdminGuard>
    ),
    children: adminRoutes,
  },
  // ===== 404 =====
  notFoundRoute,
];

/** 应用路由组件 */
export default function AppRoutes() {
  const element = useRoutes(routes);

  return <Suspense fallback={<LoadingFallback />}>{element}</Suspense>;
}
